import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: '¿Necesito experiencia previa?',
    a: 'No, está explicado desde cero. Ideal para principiantes que nunca tocaron un cable.'
  }, {
    q: '¿Cómo lo recibo?',
    a: 'Descarga inmediata en PDF. Una vez realizado el pago, accedés automáticamente al material.'
  }, {
    q: '¿Sirve para cualquier casa?',
    a: 'Sí, es electricidad básica del hogar. Los principios y arreglos aplican a la inmensa mayoría de las viviendas.'
  }, {
    q: '¿Puedo verlo desde el celular?',
    a: 'Sí, desde celular, tablet o computadora. Al ser PDF, es compatible con cualquier dispositivo.'
  }, {
    q: '¿El premium vale la pena?',
    a: 'Sí, porque incluye guías rápidas, mantenimiento y material extra para resolver más cosas y tener tu casa organizada.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-0 bg-brand-50/50 px-4 border-t border-gray-100" data-id="element-83">
      <div className="max-w-3xl mx-auto" data-id="element-84">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-85">
          <h2 className="text-3xl md:text-4xl font-heading font-bold mb-4 text-gray-900" data-id="element-86">
            ❓ PREGUNTAS FRECUENTES
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-87">
          {faqs.map((faq, index) => <motion.div key={index} className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow" initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.1
        }} data-id="element-88">
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-89">
                <span className="font-heading font-bold text-lg text-gray-900 pr-4" data-id="element-90">
                  {faq.q}
                </span>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${openIndex === index ? 'bg-brand-50' : 'bg-gray-50'}`} data-id="element-91">
                  <ChevronDown className={`w-5 h-5 text-brand-500 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-92" />
                </div>
              </button>
              <AnimatePresence data-id="element-93">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-94">
                    <div className="px-6 pb-6 text-gray-600 font-medium border-t border-gray-100 pt-4" data-id="element-95">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}